// import React from 'react';
// import './Footer.css'; // Ensure this CSS file is created for styling

// const Footer = () => {
//   return (
//     <footer id="footer">
//       <div className="footer-top">
//         <div className="container">
//           <div className="row">

//             <div className="col-lg-4 col-md-6 footer-info">
//               <h3>Al-Quran<span className="highlight"> Academy</span></h3>
//               <p>
//                 123 Knowledge Lane<br />
//                 Medina, Saudi Arabia<br />
//                 Islamic World <br /><br />
//                 <strong>Phone:</strong> +966 123456789<br />
//                 <strong>Email:</strong> contact@alquranacademy.com<br />
//               </p>
//             </div>

//             <div className="col-lg-2 col-md-6 footer-links">
//               <h4>Useful Links</h4>
//               <ul>
//                 <li><i className="fas fa-chevron-right"></i> <a href="#">Home</a></li>
//                 <li><i className="fas fa-chevron-right"></i> <a href="#">About Us</a></li>
//                 <li><i className="fas fa-chevron-right"></i> <a href="#">Courses</a></li>
//                 <li><i className="fas fa-chevron-right"></i> <a href="#">Contact Us</a></li>
//                 <li><i className="fas fa-chevron-right"></i> <a href="#">Privacy Policy</a></li>
//               </ul>
//             </div>

//             <div className="col-lg-3 col-md-6 footer-links">
//               <h4>Our Courses</h4>
//               <ul>
//                 <li><i className="fas fa-chevron-right"></i> <a href="#">Hifz</a></li>
//                 <li><i className="fas fa-chevron-right"></i> <a href="#">Tajweed</a></li>
//                 <li><i className="fas fa-chevron-right"></i> <a href="#">Quranic Arabic</a></li>
//                 <li><i className="fas fa-chevron-right"></i> <a href="#">Fiqh</a></li>
//                 <li><i className="fas fa-chevron-right"></i> <a href="#">Hadith Studies</a></li>
//               </ul>
//             </div>

//             <div className="col-lg-3 col-md-6 footer-contact-us">
//               <h4>Contact Us</h4>
//               <p>For more details or inquiries about our courses, please reach out to us via:</p>
//               <div className="contact-options">
//                 <a href="mailto:contact@alquranacademy.com" className="email"><i className="fas fa-envelope"></i> Email</a>
//                 <a href="skype:live:.cid.1234567890" className="skype"><i className="fab fa-skype"></i> Skype</a>
//                 <a href="https://wa.me/966123456789" className="whatsapp"><i className="fab fa-whatsapp"></i> WhatsApp</a>
//               </div>
//               <a href="#" className="btn btn-primary contact-btn">Contact Us</a>
//             </div>

//           </div>
//         </div>
//       </div>

//       <div className="container d-flex justify-content-between py-4">
//         <div className="copyright">
//           &copy; Copyright <strong><span>Al-Quran Academy</span></strong>. All Rights Reserved
//         </div>
//         <div className="social-links text-center text-md-end">
//           <a href="#" className="twitter"><i className="fab fa-twitter"></i></a>
//           <a href="#" className="facebook"><i className="fab fa-facebook-f"></i></a>
//           <a href="#" className="instagram"><i className="fab fa-instagram"></i></a>
//           <a href="#" className="youtube"><i className="fab fa-youtube"></i></a>
//           <a href="#" className="linkedin"><i className="fab fa-linkedin-in"></i></a>
//         </div>
//       </div>
//     </footer>
//   );
// }

// export default Footer;
import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import './Footer.css';

const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">

            <div className="col-lg-4 col-md-6 footer-info">
              <h3>Al-Quran<span className="highlight"> Academy</span></h3>
              <p>
                123 Knowledge Lane<br />
                Medina, Saudi Arabia<br />
                Islamic World <br /><br />
                <strong>Phone:</strong> +966 123456789<br />
                <strong>Email:</strong> contact@alquranacademy.com<br />
              </p>
            </div>

            <div className="col-lg-2 col-md-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li><i className="fas fa-chevron-right"></i> <Link to="/">Home</Link></li>
                <li><i className="fas fa-chevron-right"></i> <Link to="/about">About Us</Link></li>
                <li><i className="fas fa-chevron-right"></i> <Link to="/courses">Courses</Link></li>
                <li><i className="fas fa-chevron-right"></i> <Link to="/pricing">Pricing</Link></li>
                <li><i className="fas fa-chevron-right"></i> <Link to="/contact-us">Contact Us</Link></li>
               
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 footer-links">
              <h4>Our Courses</h4>
              <ul>
                <li><i className="fas fa-chevron-right"></i> <Link to="/pricing">Hifz</Link></li>
                <li><i className="fas fa-chevron-right"></i> <Link to="/pricing">Tajweed</Link></li>
                <li><i className="fas fa-chevron-right"></i> <Link to="/pricing">Quranic Arabic</Link></li>
               
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 footer-contact-us">
              <h4>Contact Us</h4>
              <p>For more details or inquiries about our courses, please reach out to us via:</p>
              <div className="contact-options">
                <a href="mailto:contact@alquranacademy.com" className="email"><i className="fas fa-envelope"></i> Email</a>
                <a href="skype:live:.cid.1234567890" className="skype"><i className="fab fa-skype"></i> Skype</a>
                <a href="https://wa.me/966123456789" className="whatsapp"><i className="fab fa-whatsapp"></i> WhatsApp</a>
              </div>
              <Link to="/contact-us" className="btn btn-primary contact-btn">Contact Us</Link>
            </div>

          </div>
        </div>
      </div>

      <div className="container d-flex justify-content-between py-4">
        <div className="copyright">
          &copy; Copyright <strong><span>Al-Quran Academy</span></strong>. All Rights Reserved
        </div>
        <div className="social-links text-center text-md-end">
          <a href="#" className="twitter"><i className="fab fa-twitter"></i></a>
          <a href="#" className="facebook"><i className="fab fa-facebook-f"></i></a>
          <a href="#" className="instagram"><i className="fab fa-instagram"></i></a>
          <a href="#" className="youtube"><i className="fab fa-youtube"></i></a>
          <a href="#" className="linkedin"><i className="fab fa-linkedin-in"></i></a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

